import styled from '@emotion/styled';
import { ErrorViewTmpl } from './templates';

const ErrorBack = styled.div`
  height: 400px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
`;

const ErrorMessageBox = styled.div`
  height: 100px;
  width: 80%;
  margin: 0 auto;
  border: 1px solid #aaaaaa;
  border-radius: 4px;
  box-shadow: 0px 8px 16px #888888;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
`;

interface ErrorMessageWithBox {
  title: string;
  message: string;
}

export function ErrorViewWithBox(props: ErrorMessageWithBox) {
  const { title, message } = props;
  return (
    <ErrorViewTmpl title={title}>
      <ErrorBack>
        <ErrorMessageBox>
          <span id="authorization-error-msg" style={{ textAlign: 'center' }}>
            {message}
          </span>
        </ErrorMessageBox>
      </ErrorBack>
    </ErrorViewTmpl>
  );
}
